module.exports = new __parcel__URL__("music.baea1521.png").toString();